
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatBraceletCode } from "@/utils/braceletUtils";

interface BraceletActivity {
  referral_code: string;
  registered: boolean;
  user_id?: string;
  user_name?: string;
  scan_count: number;
  journal_count: number;
  prayer_count: number;
}

interface BraceletActivityTableProps {
  braceletActivity: BraceletActivity[];
  isLoading: boolean;
}

export function BraceletActivityTable({
  braceletActivity,
  isLoading,
}: BraceletActivityTableProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-6">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-red-500"></div>
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Registered User</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Bracelet Code</TableHead>
          <TableHead className="text-center">Scans</TableHead>
          <TableHead className="text-center">Journals</TableHead>
          <TableHead className="text-center">Prayer Requests</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {braceletActivity.length === 0 ? (
          <TableRow>
            <TableCell colSpan={6} className="text-center py-4 text-gray-500">
              No bracelets assigned to this congregation yet.
            </TableCell>
          </TableRow>
        ) : (
          braceletActivity.map((bracelet) => (
            <TableRow key={bracelet.referral_code}>
              <TableCell>{bracelet.user_name || "—"}</TableCell>
              <TableCell>
                <span className={`px-2 py-1 rounded text-xs ${bracelet.registered ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                  {bracelet.registered ? 'Registered' : 'Unregistered'}
                </span>
              </TableCell>
              <TableCell className="font-mono">{formatBraceletCode(bracelet.referral_code)}</TableCell>
              <TableCell className="text-center">{bracelet.scan_count}</TableCell>
              <TableCell className="text-center">{bracelet.journal_count}</TableCell>
              <TableCell className="text-center">{bracelet.prayer_count}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
